<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('LMS')" :isFilter="false" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('LMS')" :isFilter="false" />
            </template>
            <b-row>
                <b-col cols="12">
                    <b-tabs content-class="mt-3" align="center" class="line-tabs" v-model="tabIndex">
                        <b-tab :title="$t('course_detail_title')">
                            <b-card
                                v-if="courseData"
                                :header="courseData.code + ' - ' + getLocaleText(courseData, 'name')"
                                header-tag="header">
                                <b-row>
                                    <b-col cols="12" md="6" class="mb-3">
                                        <b-form-group :label="$t('course_name')">
                                            <div class="label-as-input font-weight-bold">{{ getLocaleText(courseData, 'name') || '-' }}</div>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6" class="mb-3">
                                        <b-form-group :label="$t('name_en') || $t('course_name') + ' (EN)'">
                                            <div class="label-as-input font-weight-bold">{{ courseData.name_en || '-' }}</div>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6" lg="4" class="mb-3">
                                        <b-form-group :label="$t('faculty')">
                                            <div class="label-as-input">{{ getLocaleText(courseData, 'faculty_name') || courseData.faculty_name || '-' }}</div>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6" lg="4" class="mb-3">
                                        <b-form-group :label="$t('department')">
                                            <div class="label-as-input">{{ getLocaleText(courseData, 'department_name') || courseData.department_name || '-' }}</div>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6" lg="4" class="mb-3">
                                        <b-form-group :label="$t('program')">
                                            <div class="label-as-input">{{ getLocaleText(courseData, 'program_name') || courseData.program_name || '-' }}</div>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6" lg="4" class="mb-3">
                                        <b-form-group :label="$t('evaluation_type')">
                                            <div class="label-as-input">{{ getLocaleText(courseData, 'evaluation_type_name') || courseData.evaluation_type_name || '-' }}</div>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6" lg="4" class="mb-3">
                                        <b-form-group :label="$t('final_exam')">
                                            <div class="label-as-input">{{ (courseData.has_final_exam == 1 || courseData.has_final_exam === true || courseData.has_final_exam === '1') ? $t('yes') : $t('no') }}</div>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6" lg="4" class="mb-3">
                                        <b-form-group :label="$t('make_up_exam')">
                                            <div class="label-as-input">{{ (courseData.has_make_up_exam == 1 || courseData.has_make_up_exam === true || courseData.has_make_up_exam === '1') ? $t('yes') : $t('no') }}</div>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" class="mb-3" v-if="courseData.content">
                                        <b-form-group :label="$t('content')">
                                            <div class="p-3 bg-light rounded border">{{ getLocaleText(courseData, 'content') }}</div>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-tab>
                        <b-tab :title="$t('content')">
                            <b-alert variant="info" show v-if="checkStudent()">
                                <b-button variant="primary"
                                          v-if="checkPermission('lmscontent_store')"
                                          @click="openModal('ContentCreateForm', 'add_content')">
                                    {{ $t('add_content') }}
                                </b-button>
                            </b-alert>
                            <b-card
                                v-for="content in contents"
                                :key="content.id"
                                class="mb-4"
                                :header="content.title"
                                header-tag="header">
                                <b-row>
                                    <b-col cols="12" md="1" class="text-black-50">{{ $t('semester') }}</b-col>
                                    <b-col cols="12" md="11">{{ content.academic_year+' '+getLocaleText(content, 'semester_name') }}</b-col>
                                    <b-col cols="12" md="1" class="text-black-50">{{ $t('course') }}</b-col>
                                    <b-col cols="12" md="11">{{ getLocaleText(content, 'course_name') }}</b-col>
                                    <b-col cols="12" md="1" class="text-black-50">{{ $t('instructor') }}</b-col>
                                    <b-col cols="12" md="11">{{ content.instructor_name+' '+content.instructor_surname }}</b-col>
                                    <b-col cols="12" md="1" class="text-black-50">{{ $t('title') }}</b-col>
                                    <b-col cols="12" md="11">{{ content.title }}</b-col>
                                    <b-col cols="12" md="1" class="text-black-50">{{ $t('content') }}</b-col>
                                    <b-col cols="12" md="11"></b-col>
                                    <b-col cols="12" md="1" class="text-black-50">{{ $t('start') }}</b-col>
                                    <b-col cols="12" md="11">{{ content.from_date }}</b-col>
                                    <b-col cols="12" md="1" class="text-black-50">{{ $t('end') }}</b-col>
                                    <b-col cols="12" md="11">{{ content.to_date }}</b-col>
                                    <b-col cols="12" md="1" class="text-black-50 mt-2">{{ $t('homework_attach_file') }}</b-col>
                                    <b-col cols="12" md="11" class="mt-2">
                                        <b-button class="mr-2"
                                                  @click="downloadFile(content.file.uuid, content.file.file_name)"
                                                  squared
                                                  variant="primary"
                                                  v-b-tooltip.hover
                                                  v-if="content.file"
                                                  :title="content.file.file_name">
                                            <i class="ri-attachment-line" style="font-size: 25px"></i>
                                        </b-button>
                                    </b-col>
                                </b-row>
                                <template #footer v-if="checkStudent()">
                                    <b-row>
                                        <b-col cols="12" class="d-flex justify-content-center align-items-center">
                                            <b-button-group>
                                                <b-dropdown variant="primary" left :text="$t('manage')">
                                                    <b-dropdown-item
                                                        v-if="checkPermission('lmscontent_update')"
                                                        @click="openModal('ContentUpdateForm', 'edit', content.id)">
                                                        <i class="ri-edit-line"></i> {{ $t('edit') }}
                                                    </b-dropdown-item>
                                                    <b-dropdown-item
                                                        v-if="checkPermission('lmscontent_delete')"
                                                        @click="contentDelete(content.id)">
                                                        <i class="ri-delete-bin-line"></i> {{ $t('delete') }}
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                            </b-button-group>
                                        </b-col>
                                    </b-row>
                                </template>
                            </b-card>
                        </b-tab>
                        <b-tab :title="$t('homework')">
                            <b-row>
                                <b-col cols="12">
                                    <b-alert variant="info" show v-if="checkStudent()">
                                        <b-button variant="primary"
                                                  v-if="checkPermission('lmshomework_store')"
                                                  @click="openModal('HomeworkCreateForm', 'homework_entry')">
                                            {{ $t('homework_entry') }}
                                        </b-button>
                                    </b-alert>
                                    <b-card
                                        v-for="(homework, index) in homeworks"
                                        :key="homework.id"
                                        class="mb-4"
                                        :header="$t('homework')+' '+(homeworks.length -index)"
                                        header-tag="header">
                                        <b-row>
                                            <b-col cols="12" md="1" class="text-black-50">{{ $t('semester') }}</b-col>
                                            <b-col cols="12" md="11">{{ homework.academic_year+' '+getLocaleText(homework, 'semester_name') }}</b-col>
                                            <b-col cols="12" md="1" class="text-black-50">{{ $t('course') }}</b-col>
                                            <b-col cols="12" md="11">{{ getLocaleText(homework, 'course_name') }}</b-col>
                                            <b-col cols="12" md="1" class="text-black-50">{{ $t('instructor') }}</b-col>
                                            <b-col cols="12" md="11">{{ homework.instructor_name+' '+homework.instructor_surname }}</b-col>
                                            <b-col cols="12" md="1" class="text-black-50">{{ $t('content') }}</b-col>
                                            <b-col cols="12" md="11"><span v-html="homework.content ? decodeHTMLEntities(homework.content) : ''" /></b-col>
                                            <b-col cols="12" md="1" class="text-black-50">{{ $t('start') }}</b-col>
                                            <b-col cols="12" md="11">{{ homework.from_date}}</b-col>
                                            <b-col cols="12" md="1" class="text-black-50">{{ $t('end') }}</b-col>
                                            <b-col cols="12" md="11">{{ homework.due_date}}</b-col>
                                            <b-col cols="12" md="1" class="text-black-50 mt-2">{{ $t('homework_attach_file') }}</b-col>
                                            <b-col cols="12" md="11" class="mt-2">
                                                <b-button class="mr-2"
                                                          @click="downloadFile(homework.file.uuid, homework.file.file_name)"
                                                          squared
                                                          variant="primary"
                                                          v-b-tooltip.hover
                                                          v-if="homework.file"
                                                          :title="homework.file.file_name">
                                                    <i class="ri-attachment-line" style="font-size: 25px"></i>
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                        <template #footer>
                                            <b-row>
                                                <b-col cols="12" class="d-flex justify-content-center align-items-center">
                                                    <b-button-group v-if="checkStudent()">
                                                        <b-dropdown variant="primary" left :text="$t('manage')">
                                                            <b-dropdown-item
                                                                v-if="checkPermission('lmshomeworkstudent_show')"
                                                                @click="openModal('Homeworks', 'homeworks', homework.id)">
                                                                <i class="ri-file-copy-2-line"></i> {{ $t('homeworks') }}
                                                            </b-dropdown-item>
                                                            <b-dropdown-item
                                                                v-if="checkPermission('lmshomework_update')"
                                                                @click="openModal('HomeworkUpdateForm', 'edit', homework.id)">
                                                                <i class="ri-edit-line"></i> {{ $t('edit') }}
                                                            </b-dropdown-item>
                                                            <b-dropdown-item
                                                                v-if="checkPermission('lmshomework_delete')"
                                                                @click="homeworkDelete(homework.id)">
                                                                <i class="ri-delete-bin-line"></i> {{ $t('delete') }}
                                                            </b-dropdown-item>
                                                        </b-dropdown>
                                                    </b-button-group>
                                                    <b-button v-if="!checkStudent() && homework.student_submission && homework.student_submission.file"
                                                              @click="downloadStudentFile(homework.student_submission.file.uuid, homework.student_submission.file.file_name)"
                                                              class="mr-2"
                                                              squared
                                                              variant="primary"
                                                              v-b-tooltip.hover
                                                              :title="homework.student_submission.file.file_name">
                                                        <i class="ri-file-download-line" style="font-size: 25px"></i>
                                                    </b-button>
                                                    <b-button v-if="!checkStudent()"
                                                              @click="openModal('UploadHomework', 'homework_upload', homework.id)"
                                                              variant="primary"
                                                              class="ml-2"><i class="ri-upload-cloud-2-fill mr-2"></i> {{ $t('homework_upload') }}</b-button>
                                                </b-col>
                                            </b-row>
                                        </template>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab :title="$t('announcement')">
                            <b-row>
                                <b-col cols="12" v-if="checkStudent()">
                                    <b-alert variant="info" show>
                                        <b-button variant="primary"
                                                  v-if="checkPermission('lmsannouncement_store')"
                                                  @click="openModal('AnnouncementCreateForm', 'announcement_entry')">
                                            {{ $t('announcement_entry') }}
                                        </b-button>
                                    </b-alert>
                                    <b-card
                                        v-for="(announcement, index) in announcements"
                                        :key="announcement.id"
                                        class="mb-4"
                                        :header="$t('announcement_')+' '+(announcements.length - index)"
                                        header-tag="header">
                                        <b-row>
                                            <b-col cols="12" md="1" class="text-black-50">{{ $t('semester') }}</b-col>
                                            <b-col cols="12" md="11">{{ announcement.academic_year+' '+getLocaleText(announcement, 'semester_name') }}</b-col>
                                            <b-col cols="12" md="1" class="text-black-50">{{ $t('course') }}</b-col>
                                            <b-col cols="12" md="11">{{ getLocaleText(announcement, 'course_name')}}</b-col>
                                            <b-col cols="12" md="1" class="text-black-50">{{ $t('instructor') }}</b-col>
                                            <b-col cols="12" md="11">{{ announcement.instructor_name+' '+announcement.instructor_surname }}</b-col>
                                            <b-col cols="12" md="1" class="text-black-50">{{ $t('content') }}</b-col>
                                            <b-col cols="12" md="11"><span v-html="announcement.content ? decodeHTMLEntities(announcement.content) : ''" /></b-col>
                                            <b-col cols="12" md="1" class="text-black-50">{{ $t('start') }}</b-col>
                                            <b-col cols="12" md="11">{{ announcement.from_date }}</b-col>
                                            <b-col cols="12" md="1" class="text-black-50">{{ $t('end') }}</b-col>
                                            <b-col cols="12" md="11">{{ announcement.to_date }}</b-col>
                                        </b-row>
                                        <template #footer>
                                            <b-row>
                                                <b-col cols="12" class="d-flex justify-content-center align-items-center">
                                                    <b-button-group>
                                                        <b-dropdown variant="primary" left :text="$t('manage')">
                                                            <b-dropdown-item
                                                                v-if="checkPermission('lmsannouncement_update')"
                                                                @click="openModal('AnnouncementUpdateForm', 'edit', announcement.id)">
                                                                <i class="ri-edit-line"></i> {{ $t('edit') }}
                                                            </b-dropdown-item>
                                                            <b-dropdown-item
                                                                v-if="checkPermission('lmsannouncement_delete')"
                                                                @click="announcementDelete(announcement.id)">
                                                                <i class="ri-delete-bin-line"></i> {{$t('delete') }}
                                                            </b-dropdown-item>
                                                        </b-dropdown>
                                                    </b-button-group>
                                                </b-col>
                                            </b-row>
                                        </template>
                                    </b-card>
                                </b-col>
                                <b-col cols="12" v-else>
                                    <b-row>
                                        <b-col cols="12" md="4" v-for="announcement in announcements" :key="announcement.id">
                                            <b-card
                                                class="mb-4"
                                                :header="$t('announcement_')"
                                                header-tag="header">
                                                <b-row>
                                                    <b-col cols="12" class="text-black-50">
                                                        <span v-html="announcement.content ? decodeHTMLEntities(announcement.content) : ''" />
                                                    </b-col>
                                                </b-row>
                                                <template #footer>
                                                    <b-row>
                                                        <b-col cols="12" md="6" class="text-black-50">
                                                            {{ getLocaleText(announcement, 'course_name')}}
                                                        </b-col>
                                                        <b-col cols="12" md="6" class="text-black-50 text-right">
                                                            {{ announcement.instructor_name+' '+announcement.instructor_surname }}
                                                        </b-col>
                                                    </b-row>
                                                </template>
                                            </b-card>
                                        </b-col>
                                    </b-row>
                                </b-col>

                            </b-row>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </app-layout>
        <CommonModal size="xl" ref="eventModal" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()">
            <template v-slot:CommonModalTitle>
                <div>{{ modalTitle }}</div>
            </template>
            <template v-slot:CommonModalContent>
                <component v-if="selectedComponent"
                           :is="selectedComponent"
                           :course="courseData"
                           :userData="userData"
                           :semesterId="$route.params.semesterId"
                           :formId="formId"
                           @addContentSuccess="contentSuccess"
                           @homeworkSuccess="homeworkSuccess"
                           @announcementSuccess="announcementSuccess"
                />
            </template>
        </CommonModal>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout.vue"
import Header from "@/layouts/AppLayout/Header.vue"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile.vue"

// Page
import ContentCreateForm from "./content/CreateForm.vue"
import ContentUpdateForm from "./content/UpdateForm.vue"
import HomeworkCreateForm from "./homework/CreateForm.vue"
import HomeworkUpdateForm from "./homework/UpdateForm.vue"
import Homeworks from "./homework/Homeworks.vue"
import AnnouncementCreateForm from "./announcement/CreateForm.vue"
import AnnouncementUpdateForm from "./announcement/UpdateForm.vue"
import UploadHomework from "./homework/UploadHomework.vue"

// Component


// Services
import CourseService from "@/services/CourseService"
import LmsContentService from "@/services/LmsContentService"
import LmsHomeWorkEntryService from "@/services/LmsHomeWorkEntryService"
import LmsAnnouncementsService from "@/services/LmsAnnouncementsService"

//Other
import qs from "qs"

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        ContentCreateForm,
        ContentUpdateForm,
        HomeworkCreateForm,
        HomeworkUpdateForm,
        Homeworks,
        AnnouncementCreateForm,
        AnnouncementUpdateForm,
        UploadHomework
    },

    data() {
        return {
            courseData: null,
            tabIndex: 0,
            modalTitle: null,
            selectedComponent: null,
            userData: null,
            contents: null,
            formId: null,
            homeworks: null,
            announcements: null
        }
    },

    metaInfo() {
        return {
            title: this.$t("LMS")
        }
    },

    created() {
        this.getCourseData()
        this.$store.dispatch("auth/initUser");
        this.userData = this.$store.getters['auth/getUser']
    },

    watch: {
        tabIndex(val) {
            if(val == 1) {
                this.getContents()
            } else if(val == 2) {
                this.getHomeworks()
            } else if(val == 3) {
                this.getAnnouncements()
            }
        }
    },

    methods: {
        getCourseData() {
            CourseService.getByCode(this.$route.params.courseCode).then((response) => {
                this.courseData = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        getContents() {
            if(this.checkStudent()) {
                const config = {
                    params: {
                        filter: {
                            semester_id: this.$route.params.semesterId,
                            course_id: this.courseData.id
                        },
                        limit: -1,
                        sort: 'from_date'
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                LmsContentService.getAll(config).then((response) => {
                    this.contents = response.data.data
                }).catch(e => {
                    this.showErrors(e, null)
                })
            } else {
                const config = {
                    params: {
                        semester_id: this.$route.params.semesterId,
                        course_code: this.courseData.code,
                        limit: -1,
                        sort: 'from_date'
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                LmsContentService.getAllStudentContents(config).then((response) => {
                    this.contents = response.data.data
                }).catch(e => {
                    this.showErrors(e, null)
                })
            }
        },

        openModal(component, title, formId) {
            this.selectedComponent = component
            this.modalTitle = this.$t(title)
            this.formId = formId
            this.$refs.eventModal.$refs.commonModal.show()
        },

        formClear() {
            this.selectedComponent = null
            this.modalTitle = null
            this.formId = null
        },

        contentSuccess() {
            this.formClear()
            this.$refs.eventModal.$refs.commonModal.hide()
            this.getContents()
        },

        contentDelete(id) {
            this.$swal.fire({
                text: this.$t('are_you_sure_to_delete'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no')
            }).then((result) => {
                if (result.isConfirmed) {
                    LmsContentService.del(id).then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                        this.getContents()
                    }).catch(e => {
                        this.showErrors(e, null)
                    })
                }
            })
        },

        getHomeworks() {
            if(this.checkStudent()) {
                const config = {
                    params: {
                        filter: {
                            semester_id: this.$route.params.semesterId,
                            course_id: this.courseData.id
                        },
                        limit: -1,
                        sort: '-id'
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                }
                LmsHomeWorkEntryService.getAll(config).then(response => {
                    this.homeworks = response.data.data
                }).catch(e => {
                    this.showErrors(e, null)
                })
            } else {
                const config = {
                    params: {
                        semester_id: this.$route.params.semesterId,
                        course_code: this.courseData.code,
                        limit: -1,
                        sort: '-id'
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                }
                LmsHomeWorkEntryService.getAllStudentHomeworks(config).then(response => {
                    this.homeworks = response.data.data
                }).catch(e => {
                    this.showErrors(e, null)
                })
            }

        },

        homeworkSuccess() {
            this.formClear()
            this.$refs.eventModal.$refs.commonModal.hide()
            this.getHomeworks()
        },

        homeworkDelete(id) {
            this.$swal.fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                }).then((result) => {
                    if (result.isConfirmed) {
                        LmsHomeWorkEntryService.del(id).then(response => {
                            this.$toast.success(this.$t('api.' + response.data.message));
                            this.getHomeworks()
                        }).catch(error => {
                            this.$toast.error(this.$t('api.' + error.data.message));
                        })
                    }
                })
        },

        getAnnouncements() {
            if(this.checkStudent()) {
                const config = {
                    params: {
                        filter: {
                            semester_id: this.$route.params.semesterId,
                            course_id: this.courseData.id
                        },
                        limit: -1,
                        sort: '-from_date'
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                LmsAnnouncementsService.getAll(config).then(response => {
                    this.announcements = response.data.data
                }).catch(e => {
                    this.showErrors(e, null)
                })
            } else {
                const config = {
                    params: {
                        semester_id: this.$route.params.semesterId,
                        course_code: this.courseData.code,
                        limit: -1,
                        sort: '-from_date'
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                LmsAnnouncementsService.getAllStudentAnnouncements(config).then(response => {
                    this.announcements = response.data.data
                }).catch(e => {
                    this.showErrors(e, null)
                })
            }

        },

        announcementSuccess() {
            this.formClear()
            this.$refs.eventModal.$refs.commonModal.hide()
            this.getAnnouncements()
        },

        announcementDelete(id) {
            this.$swal.fire({
                text: this.$t('are_you_sure_to_delete'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no')
            }).then((result) => {
                if (result.isConfirmed) {
                    LmsAnnouncementsService.del(id).then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message))
                        this.getAnnouncements()
                    }).catch(error => {
                        this.$toast.error(this.$t('api.' + error.data.message))
                    })
                }
            })
        },

        checkStudent() {
            if(this.userData.active_role.name == 'OGR') {
                return false
            }
            return true
        },

        downloadFile(uuid, filename) {
            LmsHomeWorkEntryService.downloadFile(uuid).then(response=>{
                    this._downloadFile(response, filename)
                }).catch(e => {
                this.showErrors(e, null)
            })
        },

        downloadStudentFile(uuid, filename) {
            LmsHomeWorkEntryService.downloadSudentFile(uuid).then(response=>{
                this._downloadFile(response, filename)
            }).catch(e => {
                this.showErrors(e, null)
            })
        }

    },
}
</script>
<style scoped>
.cursor {
    cursor: pointer;
}
</style>
